import request from '@/utils/request'

/**
 * 批量取消分享链接
 *
 * @param {object} params 包含分享数据标识集合信息
 */
export function cancelShare (params) {
  return request({
    url: '/op/opShare/delete',
    method: 'post',
    data: params
  })
}

/**
 * 创建文件分享链接
 *
 * @param {object} params 包含文件标识列表、是否需要提取码、过期时间等参数信息
 */
export function createShare (params) {
  return request({
    url: '/op/opApp/createShareCode',
    method: 'post',
    data: params
  })
}

/**
 * 移动文件
 *
 * @param {object} params 包含文件标识列表、是否需要提取码、过期时间等参数信息
 */
export function appMove (params) {
  return request({
    url: '/op/opApp/appMove',
    method: 'post',
    data: params
  })
}

/**
 * 获取文件夹列表
 *
 * @param {object} params 包含文件标识列表、是否需要提取码、过期时间等参数信息
 */
export function findFolderList (params) {
  return request({
    url: '/op/opApp/findFolderList',
    method: 'post',
    data: params
  })
}

/**
 * 我的分享记录列表
 *
 * @param {object} params 包含页码等参数
 */
export function share (params) {
  return request({
    url: '/op/opShare/list',
    method: 'post',
    data: params
  })
}

/**
 * 分享详情
 *
 * @param {object} params 包含分享短链、提取码等参数信息
 */
export function shareDetail (params) {
  return request({
    url: '/disk-share/share-detail',
    method: 'get',
    params
  })
}

/**
 * 获取分享的文件列表
 *
 * @param {object} params 包含需要搜索的文件参数信息
 */
export function search (params) {
  params.pageSize = 100
  return request({
    url: '/disk-share/share-file',
    method: 'get',
    params
  })
}

/**
 * 获取分享文件展示状态
 *
 * @param {object}
 */
export function getShareFileStatus (params) {
  params.pageSize = 100
  return request({
    url: '/op/opShare/getShareFileStatus',
    method: 'post',
    params
  })
}

/**
 * 设置分享文件展示状态
 *
 * @param {object}
 */
export function updateShareFileStatus (params) {
  params.pageSize = 100
  return request({
    url: '/op/opShare/updateShareFileStatus',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/share.js